export default ({keys, server}) => {
  return `#import "CheckoutViewController.h"
{+load-stripe}
@import Stripe;
{/load-stripe}

NSString *const BackendUrl = @"http://127.0.0.1:4242/";

@interface CheckoutViewController ()  <STPAuthenticationContext>

@property (weak) STPPaymentCardTextField *cardTextField;
@property (weak) UIButton *payButton;
@property (strong) NSString *paymentIntentClientSecret;

@end

@implementation CheckoutViewController

- (void)viewDidLoad {
  [super viewDidLoad];
  self.view.backgroundColor = [UIColor whiteColor];

  {+publishable-key}
  [StripeAPI setDefaultPublishableKey:@"${keys.publishable}"];
  {/publishable-key}

  {+define-form}
  // Set up the Stripe card text field
  STPPaymentCardTextField *cardTextField = [[STPPaymentCardTextField alloc] init];
  self.cardTextField = cardTextField;

  UIButton *button = [UIButton buttonWithType:UIButtonTypeCustom];
  button.layer.cornerRadius = 5;
  button.backgroundColor = [UIColor systemBlueColor];
  button.titleLabel.font = [UIFont systemFontOfSize:22];
  [button setTitle:@"Pay" forState:UIControlStateNormal];
  [button addTarget:self action:@selector(pay) forControlEvents:UIControlEventTouchUpInside];
  self.payButton = button;

  UIStackView *stackView = [[UIStackView alloc] initWithArrangedSubviews:@[cardTextField, button]];
  stackView.axis = UILayoutConstraintAxisVertical;
  stackView.translatesAutoresizingMaskIntoConstraints = NO;
  stackView.spacing = 20;
  [self.view addSubview:stackView];

  [NSLayoutConstraint activateConstraints:@[
    [stackView.leftAnchor constraintEqualToSystemSpacingAfterAnchor:self.view.leftAnchor multiplier:2],
    [self.view.rightAnchor constraintEqualToSystemSpacingAfterAnchor:stackView.rightAnchor multiplier:2],
    [stackView.topAnchor constraintEqualToSystemSpacingBelowAnchor:self.view.safeAreaLayoutGuide.topAnchor multiplier:2],
  ]];
  {/define-form}

  [self startCheckout];
}

- (void)displayAlertWithTitle:(NSString *)title message:(NSString *)message {
  dispatch_async(dispatch_get_main_queue(), ^{
    UIAlertController *alert = [UIAlertController alertControllerWithTitle:title message:message preferredStyle:UIAlertControllerStyleAlert];

    [alert addAction:[UIAlertAction actionWithTitle:@"OK" style:UIAlertActionStyleCancel handler:nil]];
    [self presentViewController:alert animated:YES completion:nil];
  });
}

- (void)startCheckout {
  {+fetch-pi}
  // Create a PaymentIntent by calling your server's endpoint.
  NSURL *url = [NSURL URLWithString:[NSString stringWithFormat:@"%@${
    server === 'php' ? 'create.php' : 'create-payment-intent'
  }", BackendUrl]];
  NSDictionary *json = @{
      @"items": @[
        @{@"id": @"xl_tshirt"}
      ]
  };
  NSData *body = [NSJSONSerialization dataWithJSONObject:json options:0 error:nil];
  NSMutableURLRequest *request = [[NSURLRequest requestWithURL:url] mutableCopy];
  [request setHTTPMethod:@"POST"];
  [request setValue:@"application/json" forHTTPHeaderField:@"Content-Type"];
  [request setHTTPBody:body];
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:request completionHandler:^(NSData *data, NSURLResponse *response, NSError *requestError) {
    NSError *error = requestError;

    NSHTTPURLResponse *httpResponse = (NSHTTPURLResponse *)response;
    if (error != nil || httpResponse.statusCode != 200) {
      [self displayAlertWithTitle:@"Error loading page" message:error.localizedDescription ?: @""];
    }
    else {
      NSLog(@"Created PaymentIntent");
      self.paymentIntentClientSecret = json[@"clientSecret"];
    }
  }];
  {/fetch-pi}
  [task resume];
}

- (void)pay {
  if (!self.paymentIntentClientSecret) {
      NSLog(@"PaymentIntent hasn't been created");
      return;
  }

  {+collect-details}
  // Collect card details
  STPPaymentMethodCardParams *cardParams = self.cardTextField.cardParams;
  STPPaymentMethodParams *paymentMethodParams = [STPPaymentMethodParams paramsWithCard:cardParams billingDetails:nil metadata:nil];
  STPPaymentIntentParams *paymentIntentParams = [[STPPaymentIntentParams alloc] initWithClientSecret:self.paymentIntentClientSecret];
  paymentIntentParams.paymentMethodParams = paymentMethodParams;
  {/collect-details}

  {+finish}
  // Submit the payment
  STPPaymentHandler *paymentHandler = [STPPaymentHandler sharedHandler];
  [paymentHandler confirmPayment:paymentIntentParams withAuthenticationContext:self completion:^(STPPaymentHandlerActionStatus status, STPPaymentIntent *paymentIntent, NSError *error) {
    dispatch_async(dispatch_get_main_queue(), ^{
  {/finish}
  {+handle-response}
      switch (status) {
        case STPPaymentHandlerActionStatusFailed: {
          [self displayAlertWithTitle:@"Payment failed" message:error.localizedDescription ?: @""];
          break;
        }
        case STPPaymentHandlerActionStatusCanceled: {
          [self displayAlertWithTitle:@"Payment canceled" message:error.localizedDescription ?: @""];
          break;
        }
        case STPPaymentHandlerActionStatusSucceeded: {
          [self displayAlertWithTitle:@"Payment succeeded" message:paymentIntent.description ?: @""];
          break;
        }
        default:
          break;
      }
  {/handle-response}
    });
  }];
}

# pragma mark STPAuthenticationContext
- (UIViewController *)authenticationPresentingViewController {
  return self;
}

@end
`;
};
